import request from '../utils/request'


export function IndexImgList(data){
  return request({
    url: '/rest/index/img',
    method: 'post',
    data
  })
}

// 经脉列表
export function GetMeridiansListService (data) {
  return request({
    url: `/rest/meridians/list`,
    method: 'post',
    data
  })
}

// 部位列表
export function BodyList (data) {
  return request({
    url: '/rest/body/list',
    method: 'post',
    data
  })
}

// 经脉详情
export function MeridiansInfoService (data) {
  return request({
    url: `/rest/meridians/info`,
    method: 'post',
    data
  })
}

// 部位详情
export function BodyInfo (data) {
  return request({
    url: '/rest/body/info',
    method: 'post',
    data
  })
}

// 穴位列表
export function AcupointList (data) {
  return request({
    url: '/rest/acupoint/list',
    method: 'post',
    data
  })
}

// 穴位详情
export function AcupointInfo (data) {
  return request({
    url: '/rest/acupoint/info',
    method: 'post',
    data
  })
}

// 方法分类列表
export function CategoryList (data) {
  return request({
    url: '/rest/category/list',
    method: 'post',
    data
  })
}

// 分类信息
export function CategoryInfo (data) {
  return request({
    url: '/rest/category/info',
    method: 'post',
    data
  })
}

// 护理列表
export function NursingList(data){
  return request({
    url: '/rest/nursing/list',
    method: 'post',
    data
  })
}

// 护理详情
export function NursingInfoList(data){
  return request({
    url: '/rest/nursing/info',
    method: 'post',
    data
  })
}

// // 方法列表
// export function FunctionList (data) {
//   return request({
//     url: '/rest/function/list',
//     method: 'post',
//     data
//   })
// }

// // 方法详情
// export function FunctionInfo (data) {
//   return request({
//     url: '/rest/function/info',
//     method: 'post',
//     data
//   })
// }

// // 艾灸常识列表
// export function KnowledgeList (data) {
//   return request({
//     url: '/rest/knowledge/list',
//     method: 'post',
//     data
//   })
// }

// // 艾灸方法详情
// export function KnowledgeInfo (data) {
//   return request({
//     url: '/rest/knowledge/info',
//     method: 'post',
//     data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/index.js